import React from 'react';
import { useSelector } from 'react-redux';
import { convertDatePtBr } from 'utils/dateFormatter';
import * as S from './style';

export default function CardDadosPessoais({ dadosInputs }) {
  const inputSelectOptionsSexo = useSelector(state => state.inputs.inputSelectOptionsSexo);
  const inputSelectOptionsEscolaridade = useSelector(state => state.inputs.inputSelectOptionsEscolaridade);
  const inputSelectOptionsProfissao = useSelector(state => state.inputs.inputSelectOptionsProfissao);

  return (
    <S.CardInputs className="boxShadow">
      <S.CardInputsTitulo>Dados Pessoais</S.CardInputsTitulo>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Nome:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.nome}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Nome Social:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.nomeSocial}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>CPF:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.cpf}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Data de Nascimento:</S.CardInputsLabel>
        <S.CardInputsDescricao>{convertDatePtBr(dadosInputs?.dataNascimento)}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Sexo:</S.CardInputsLabel>
        <S.CardInputsDescricao>
          {inputSelectOptionsSexo?.find(x => x.id === dadosInputs?.sexoId)?.descricao}
        </S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>E-mail:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.email}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Telefone:</S.CardInputsLabel>
        <S.CardInputsDescricao>{dadosInputs?.telefone}</S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Escolaridade:</S.CardInputsLabel>
        <S.CardInputsDescricao>
          {inputSelectOptionsEscolaridade?.find(x => x.id === dadosInputs?.escolaridadeId)?.descricao}
        </S.CardInputsDescricao>
      </S.CardInputsContainerLabel>

      <S.CardInputsContainerLabel>
        <S.CardInputsLabel>Profissão:</S.CardInputsLabel>
        <S.CardInputsDescricao>
          {inputSelectOptionsProfissao?.find(x => x.id === dadosInputs?.profissaoId)?.descricao}
        </S.CardInputsDescricao>
      </S.CardInputsContainerLabel>
    </S.CardInputs>
  );
}
